import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Lowversion = _resolveComponent("Lowversion")!

  return (_ctx.highversion)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["star-xp-gate", { 'is-light': _ctx.isLight }]),
        style: _normalizeStyle(_ctx.themeCssVars)
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 6))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([_ctx.xpTheme, "versiontip"])
      }, [
        _createVNode(_component_Lowversion, { na: _ctx.na }, null, 8, ["na"])
      ], 2))
}